<div>
    <mat-form-field class="full-width">
        @if (label) {
            <mat-label>{{ label }}</mat-label>
        }
        <mat-chip-grid #chipGrid aria-label="multi autocomplete selection">
            @for (item of selection; track item) {
                @if (!allSelected) {
                    <mat-chip-row
                        [removable]="removable"
                        (removed)="remove(item)">
                            {{ item["Display"] }}
                        @if (removable) {
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        }
                    </mat-chip-row>
                }
            }
            <input placeholder="{{ placeholder ? (allSelected ? 'All ' + name + ' selected' : placeholder) : null }}"
                #autoInput
                [formControl]="myControl"
                [matChipInputFor]="chipGrid"
                [matAutocomplete]="auto"/>
            @if (selection.length == 0 && !allSelected && hint && !(myControl.errors && myControl.hasError('invalid'))) {
                <mat-hint style="margin-right:10px;">{{ hint }}</mat-hint>
            }
            @if (enableall) {
                <mat-checkbox
                    (change)="toggleAll($event.checked);"
                    [checked]="allSelected"
                    [indeterminate]="!allSelected && selection.length > 0">{{ allSelected ? "Deselect" : "Select" }} All
                </mat-checkbox>
            }
            @if ((selection.length > 0 || allSelected) && !myControl.disabled) {
                <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="reset($event);">
                    <mat-icon>close</mat-icon>
                </button>
            }
        </mat-chip-grid>
    </mat-form-field>
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)='itemSelected($event.option.value);'>
        @for (option of filteredOptions | async; track option) {
          <mat-option [value]="option">{{ option["Display"] }}</mat-option>
        }
    </mat-autocomplete>
</div>
